export { DiamondTextIcon } from "./DiamondTextIcon";
